import React, { useState, useEffect } from 'react';
import { X, Info } from 'lucide-react'; // Assuming you're using lucide-react for icons

const CookiesModal = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if the user has already accepted cookies
        const hasAcceptedCookies = localStorage.getItem('cookiesAccepted');
        if (!hasAcceptedCookies) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookiesAccepted', 'true');
        setIsVisible(false);
        if (onClose) onClose();
    };

    const handleDecline = () => {
        // Optional: Handle decline logic (e.g., disable non-essential cookies)
        localStorage.setItem('cookiesAccepted', 'false');
        setIsVisible(false);
        if (onClose) onClose();
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleDecline}></div>
            <div className="relative bg-white rounded-lg shadow-xl p-6 max-w-lg w-full mx-4">
                <button
                    onClick={handleDecline}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                >
                    <X className="h-5 w-5" />
                </button>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">We Use Cookies</h2>
                <p className="text-gray-600 mb-4">
                    This website uses cookies to enhance your experience, analyze traffic, and provide personalized content. By continuing, you agree to our use of cookies as described in our{' '}
                    <a
                        href="/cookies-policy"
                        className="text-blue-600 hover:underline"
                        onClick={(e) => e.stopPropagation()}
                    >
                        Cookies Policy
                    </a>.
                </p>
                <div className="flex justify-end space-x-4">
                    <button
                        onClick={handleDecline}
                        className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100"
                    >
                        Decline
                    </button>
                    <button
                        onClick={handleAccept}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookiesModal;